<template src= "./registration.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import swal from 'sweetalert2'
import agTableComp from '@/optionData/agTableComp'
import axios from 'axios'
import { getMetadata, getThumbnails } from 'video-metadata-thumbnails';


export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">{{title}}</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.title ? this.params.title : '선택'
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const BtnDelete = Vue.extend({
  name : 'btnDelete',
  template: `
        <button style="height:30px; line-height:30px; padding:0 1rem;" @click="btnClickedHandler()" type="button" name="button" class="vs-component vs-button vs-button-dark vs-button-filled" >
          <span class="vs-button-text vs-button--text"> {{title}} </span>
          <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);">
          </span>
        </button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export const DownLink = Vue.extend({
  name : 'downLink',
  template: `
      <a  target='_blank' :href='file' @click="btnClickedHandler2()" download>{{title}}</a>
    `,
  data(){
    return{
      title : '',
      name : '',
      file : ''
    }
  },
  created(){
    this.title = this.params.data.display_name
    this.file = this.params.data.remote_path
  },
  methods: {
    btnClickedHandler2() {
    }
  },
});
export const Radio = Vue.extend({
   name : 'radio',
  template: `
    <div style="height:100%; display:flex" >
      <vs-radio :disabled="disabled"  vs-name="checkLicensor"  v-model="check" :vs-value="value"></vs-radio>
    </div>
    `,
  data(){
    return{
      check : null,
      value : null,
      disabled : false
    }
  },
  watch :{
    'check'(e){
      this.btnClickedHandler()
    }
  },
  created(){
    this.check = this.params.context.componentParent.selectLicensor ? this.params.context.componentParent.selectLicensor.id : null
    this.value = this.params.value
    if(this.params.data.licensor.contractor_id != null) {
      this.disabled =true
    }
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
  
})
export const CheckBox = Vue.extend({
  name : 'checkBox',
  template: `

      <vs-checkbox class="inline-flex mt-2" v-model="check"></vs-checkbox>
    `,
  data(){
    return{
      check : false,
      value : {},
      disabled : false
    }
  },
  watch :{
    'check'(e){
      
      this.btnClickedHandler()
      let a = this.params.context.componentParent.selectAlbum
      const idx = a.findIndex((item) => {return item.id === this.value.id})
      if(e == true){
        if(idx < 0){
          this.params.context.componentParent.selectAlbum.push(this.value);
        }
      }else{
        this.params.context.componentParent.selectAlbum.splice(idx,1)
      }
    }
  },
  
  created(){
    let t = this.params.context.componentParent.selectAlbum
    this.value = this.params.data
    for(var i in t){
      if(t[i].id == this.value.id){
        this.check = true
      }
    }
    
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
  name: 'albumDetail',
  data() {
    return {
      
      ko : ko,
      //
      gridOptions :{ // 테이블 옵션
        context: {
          componentParent: this
        },
        onRowClicked: (event)=>{
            
        },
      },
      gridOptions2 :{ // 테이블 옵션
        context: {
          componentParent: this
        },
        onRowClicked: (event)=>{
            
        },
      },
      defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          
          suppressMenu: false,
          rowSelection:'single'
      },
      columnDefs: [
        {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
        {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
          cellRenderer: (data) => {
            let name = `${(data.data.licensor.family_name ? data.data.licensor.family_name : '')} ${(data.data.licensor.given_name ? data.data.licensor.given_name : '')}`
            var pattern3 = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; //한글
            if(pattern3.test(name)){
                name = `${(data.data.licensor.family_name ? data.data.licensor.family_name : '')} ${(data.data.licensor.given_name ? data.data.licensor.given_name : '')}`
            }else{
                name = `${(data.data.licensor.given_name ? data.data.licensor.given_name : '')} ${(data.data.licensor.family_name ? data.data.licensor.family_name : '')}` 
            }
                
          return name 
        }},
        {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,
          cellRenderer: (data) => {
            
          let company = data.value ? data.value : ''
          return company 
        }},
        {headerName: '사업자구분', field: 'licensor.entity', filter: false,width: 150,
            cellRenderer: (data) => {
            let dd ={
                'corporation': '사업자',
                'individual' :'개인'
            }
            let val = data.value ? data.value : ''
            let text = dd[val];
            if(data.value == 'corporation'){
              
              if( data.data.entity_tax_exemption == true){
                  text = dd[val] + ' (면세)'    
              }else{
                  text = dd[val] + ' (비면세)'    
              }
            }
            
            return text
        }},
        {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 100,
          cellRenderer: (data) => {
            
            return data.value.toUpperCase()
        }},
        {headerName: '거주국가(세율)', field: 'licensor.entity_address', filter: false,width: 190,
          cellRenderer: (data) => {
            let text = `
              ${data.value.country} (${data.data.licensor.entity_tax_rate}%)
            `
            return text
        }},
        {headerName: '기본정산요율', field: 'licensor.currency', filter: false,width: 190,
          cellRenderer: (data) => {
            let t1 = "한국 : "  +data.data.licensor.default_service_fee_kr
            let t2 = "해외 : "  +data.data.licensor.default_service_fee_other
            
            
            
            return `${t1}% \ ${t2}%`
        }},
        {headerName: '상세보기', field: 'id', filter: false,width: 120,cellRenderer: (data) => {
          return `
          <a class="vs-component vs-button mr-3 vs-button-primary vs-button-gradient" href='/member/detail/${data.value}' target="_blank">
          
          <span class="vs-button-text vs-button--text">상세보기</span>
          </a>`
        }},
      ],
     
      // 라이센서 추가
      gridOptions5 :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
            componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents : {
          btnSelect : BtnSelect
        }
      },
      selectLicensor : [],
      columnDefsUser : [
          {headerName: '선택', field: 'email', filter: false,width: 100,
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.selectLicensorData(data)
                this.context.componentParent.closeModal('licensor')
              }
            },
            cellRenderer: 'btnSelect'
          },
          {headerName: 'E-mail ID', field: 'email', filter: false,width: 220,},
          {headerName: '권리자명 (성 이름)', field: 'licensor.family_name', filter: false,width: 150,
            cellRenderer: (data) => {
              let fm = data.data.licensor.family_name ? data.data.licensor.family_name : '';
              let gm = data.data.licensor.given_name ? data.data.licensor.given_name : '' ;
              return fm +' '+ gm
          }},
          {headerName: '회사명', field: 'licensor.company', filter: false,width: 150,},
          
          {headerName: '정산화폐', field: 'licensor.currency', filter: false,width: 150,
            cellRenderer: (data) => {
              const type = {
                  'krw' : 'KRW',
                  'usd' : 'USD',
                  'eur' : 'EUR',
              }
              return type[data.value]
          }},
          {headerName: '사업자여부', field: 'licensor.entity', filter: false,width: 150, cellRenderer: (data) => {
              const type = {
                  'individual' : '개인',
                  'corporation' : '사업자',
              }
              return type[data.value]
          }},
          {headerName: '거주국가',  field: 'licensor.entity_address.country',  filter: false,width: 155,},
          {headerName: 'MIMS',  field: 'licensor.mims_account',  filter: false,width: 155,},
          {headerName: '정산요율', field: 'licensor.default_service_fee_kr', filter: false,width: 200, cellRenderer: (data) => {
              let text = ""
              text += "국내 : " + data.value + '%   '
              text += "해외 : " + data.data.licensor.default_service_fee_other + '%'
              return text
          }},
      ],
      keywordType : {label:'권리자명', value:'_name'},
      licensorKeyword : '',
      memberOption : optionData.memberKeyword,
      userList: {
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,                
      },
      gridOptionsUser :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
        context: {
          componentParent: this
        },
        onGridReady: function (event) {
        },
        frameworkComponents :agTableComp,
      },
      ////// 앨범
      albumGridOptions : {
        frameworkComponents :agTableComp,
      },
      //앨범 찾기 
      albumList : {
        keywordType : null,
        keyword : null,
        listData: [],                 
        pageSize: 10,                 
        currentPage: 1,
        totalPage: 0,
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          frameworkComponents : {
            btnDelete : BtnDelete,
            downLink : DownLink,
            radio : Radio,
            checkBox : CheckBox,
            textRender : agTableComp.textRender
          }
        },
        columnDefs : [
          
          {headerName: '선택',  field: 'release_date',  filter: false,width: 130,
            cellRendererParams: {
              clicked: function(data) {
                
                //this.context.componentParent.closeModal('licensor')
              }
            },
            cellRendererSelector: (data) => {
                if( data.data.advancepayment_id){
                  return { 
                    component: 'textRender',
                    params: {
                      text: '선급금상계대상'
                    }
                  }
                }else{
                  return { 
                    component: 'checkBox',
                    params: {
                      ...data.data,
                    }
                  }
                }
            }
          },
          {headerName: '발매일',  field: 'release_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 150},
          {headerName: '앨범명', field: 'name', filter: false,width: 200,},
          {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
            cellRenderer: (data) => {
              let t = data.value
              let text =  ''
              for ( var i in t ){
                if(i != 0){
                  text += ', '
                }
                text += t[i].display_name
                
              }
              return text
          }},
          {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
        ],
      },
      albumOption :[
        {value: 'name', label:'앨범명'},
        {value: 'album_ref',label: '자사앨범코드'},
        {value: 'barcode',label: 'UPC',},
        {value: 'artist',label: '아티스트명',},
        {value: 'artist_english',label: '아티스트명(번역)',},
      ],
      selectAlbumColum : [
          {headerName: '상태',  field: 'state',  filter: false,width: 100, cellRenderer: (data) => {
              let dd = {
                  temporary :'임시저장',
                  registration_complete : '접수', 
                  registration_canceled : '유통 취소', 
                  inspection_complete : '검수 완료', 
                  distribution_complete : '유통 완료', 
                  release_complete : '발매 완료', 
                  suspended : '유통중단', 
                  rejected : '반려',
                  trash : '임시삭제'
              }
              let color = {
                  temporary : "#9544d0b3",//'임시저장',
                  registration_complete : '#262c49',//'접수', 
                  registration_canceled : '#797979',//'유통 취소', 
                  inspection_complete : '#4092ff',//'검수 완료', 
                  distribution_complete : '#ff9f43',//'유통 완료', 
                  release_complete : '#24c1a0',//'발매 완료', 
                  suspended : '#b8c2cc',//'유통중단', 
                  rejected : '#ea5455',//'반려' 
                  trash : "#737373"
              }
          return `
          <div class="con-vs-chip vs-chip-primary con-color" 
          style="
              background-color: ${color[data.value]} !important;
              color:#fff;
              line-height:1;
              padding:3px 5px;
              margin:13px 0; 
              font-size:13px;
              min-width:50px;
          ">
              <span style="margin:0" class="text-chip vs-chip--text">
              ${dd[data.value]}
          </span><!----></div>`
          }},
          {headerName: '발매일',  field: 'release_date',  filter: false,width: 150,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 150},
          {headerName: '앨범명', field: 'name', filter: false,width: 200,},
          {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
            cellRenderer: (data) => {
              let t = data.value
              let text =  ''
              for ( var i in t ){
                if(i != 0){
                  text += ', '
                }
                text += t[i].display_name
                
              }
              return text
          }},
          {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
          {headerName: '상세보기', field: 'id', filter: false,width: 120,cellRenderer: (data) => {
          return `
          <a class="vs-component vs-button mr-3 vs-button-primary vs-button-gradient" href='/album/detail/${data.value}' target="_blank">
          
          <span class="vs-button-text vs-button--text">상세보기</span>
          </a>`
        }},
      ],

      selectAlbum : [
      ],

      // 선급금 계약 편집데이터
      selectAdvanceData :{},


      advanceData : {
        start_date : null,
        ref_code : null,
        amount_total : 0,
        service_fee : 0,
        amount_remaining :0,
        albums : [],
        files: [],
        listData: [],                 
        pageSize: 5,                 
        currentPage: 1,
        totalPage: 0,
        gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
          context: {
              componentParent: this
          },
          frameworkComponents : {
            btnDelete : BtnDelete,
            downLink : DownLink,
            radio : Radio
          }
        },
        columnDefs : [
          
          {headerName: '발매일',  field: 'release_date',  filter: false,width: 130,
          cellRenderer: (data) => {
            return this.fixDate(data.value, 'yyyy-MM-dd')
          }},
          
          {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 130},
          {headerName: '앨범명', field: 'name', filter: false,width: 250,
          cellRenderer: (data) => {
            if(data.data.state =='trash'){
              return '<span style="color:red"> 임시삭제 - </span>' + data.value 
            }else{
              return data.value
            }
            
          }},
          {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
            cellRenderer: (data) => {
              let t = data.value
              let text =  ''
              for ( var i in t ){
                if(i != 0){
                  text += ', '
                }
                text += t[i].display_name
              }
              return text
          }},
          {headerName: '트랙수', field: 'track_count', filter: false,width: 80,},
          
          {headerName: '삭제',  field: 'created_at',  filter: false,width: 100,
            cellRenderer: 'btnDelete',
            cellRendererParams: {
              clicked: function(data) {
                this.context.componentParent.delete_album(data)
                //this.context.componentParent.closeModal('licensor')
              }
            },
          }
        ],
      },
      advanceDataType : null,
      albumOption :[
        {value: 'email', label:'Email ID'},
        {value: '_name', label:'앨범명'},
        {value: 'company', label: '회사명'},
        {value: 'album_ref',label: '자사앨범코드'},
        {value: 'barcode',label: 'UPC',},
        {value: 'artist',label: '아티스트명',},
        {value: 'artist_english',label: '아티스트명(번역)',},
      ],
    }
  },
  mounted(){
 
   this.$nextTick((vue) =>{
      if(this.$route.params){
        //this.datacall();
     
      }
    })
  },
  watch:{
    'userList.currentPage'(){
      this.getUserList()
    },
    
    'albumList.currentPage'(){
      this.albumCall()
    },
  },
  computed:{
    
  },
  methods: {
   
    openLicensor(){
      this.userList.currentPage = 1
      this.keywordType =  {label:'권리자명', value:'_name'},
      this.licensorKeyword = '',
      this.openModal('licensor');
      this.getUserList()
    },
    getUserList(){
      const option = {
        sort: 'created_at',
        sortorder: 'desc',
        role : 'licensor',
        page: this.userList.currentPage-1 ,
        limit: this.userList.pageSize
      }
      if(this.keywordType && this.keywordType !='') {
          option[this.keywordType.value] = this.licensorKeyword
      }
      this.$store.dispatch('GETUSER', option)
      .then(result =>{
          this.userList.listData  = result.items // 권리자 목록
          //페이지 수
          const remainder = parseInt(result.filtered % this.userList.pageSize) > 0? 1: 0
          this.userList.totalPage = parseInt(result.filtered /this.userList.pageSize) + remainder
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    selectLicensorData (data){
      this.selectLicensor= [data]
      this.selectAlbum = []
    },
    openAlbum(){
      if(!this.selectLicensor[0]){
        this.alert({msg: '권리자를 선택해주세요.'})
        return false
      }
      this.openModal('album')
      this.albumList = {
        ...this.albumList,
        keywordType : null,
        keyword : null,
        listData: [],                 
        pageSize: this.albumList.pageSize,                 
        currentPage: 1,
        totalPage: 0,
      }
      this.albumCall()
    },
    getAlbumList(){
      this.albumList.currentPage = 1
      this.albumCall()
    },
    albumCall(){
      const payload = {
        id:this.selectLicensor[0].licensor.id,
        params:{
          sort: 'created_at',
          sortorder: "desc",
          page: this.albumList.currentPage - 1,
          limit: this.albumList.pageSize,
          _ap: false
        }
      }
      if(this.albumList.keywordType && this.albumList.keywordType != '') {
        payload.params[this.albumList.keywordType.value] = this.albumList.keyword
      }
      this.loadingShow();
      this.$store.dispatch('GETOFFSETTINGALBUMLIST', payload)
      .then(result =>{
        this.loadingHide();
        this.albumList.listData  = result.items // 권리자 목록
        //페이지 수
        const remainder = parseInt(result.filtered % this.albumList.pageSize) > 0? 1: 0
        this.albumList.totalPage = parseInt(result.filtered /this.albumList.pageSize) + remainder
          
      }).catch(error=>{
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
            break;
          }
      })
    },
    delete_album(data){
      
      this.confirm({
        title : '상계대상 삭제',
        msg : `
            선택하신 상계대상을 삭제하시겠습니까?
        `,
        action : ()=>{
          console.log(this.selectAlbum)
          this.loadingShow()
          const a = this.selectAlbum
          const idx = a.findIndex((item) => {return item.id === data.id})
          this.selectAlbum.splice(idx,1)
          setTimeout(() => {
            this.loadingHide()
          }, 300);
        
        }
      })
      
    },
    saveAdvance(){
      if(!this.selectLicensor[0]){
        this.alert({msg: '권리자를 선택해주세요.'})
        return false
      }
      const payload = {
        id : this.selectLicensor[0].licensor.id,
        params: {
          start_date :this.advanceData.start_date,
          amount_total : this.advanceData.amount_total,
          service_fee :	this.advanceData.service_fee,
          albums :[],
          files : [],
        }
      }
      
      if(this.valCheck(this.advanceData.start_date)){
        this.alert({msg:'계약시작일을 입력해주세요.'})
        return false
      }
      if(this.valCheck(this.advanceData.amount_total) && this.advanceData.amount_total == 0){
        this.alert({msg:'선급금액을 입력해주세요.'})
        return false
      }
      if(this.valCheck(this.advanceData.service_fee)&& this.advanceData.service_fee == 0){
        this.alert({msg:'선급금정산요율을 입력해주세요.'})
        return false
      }
      if(this.advanceData.service_fee > 100){
        this.alert({msg:'선급금정산요율은 100%를 넘을수 없습니다.'})
        return false
      }
      for(var j in this.selectAlbum){
        payload.params.albums.push({id : this.selectAlbum[j].id})
      }
      
      this.loadingShow()
      this.$store.dispatch('POSTADVANCEPAYMENT', payload)
      .then(result =>{
          
          //페이지 수
          this.noti('선급금계약이 추가되었습니다.')
          this.loadingHide()
          this.$router.push('/advancepayment')
      }).catch(error=>{
          this.loadingHide()
          const status = error.response.status
          switch(status){
            case 401:
            this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
            break;
            default:
              this.alert({msg: error.response.data.message})
            break;
          }
      })
      
    },
  }
}
</script>

<style scoped>

</style>
